<template>
  <div class="lg:max-w-4xl mx-auto my-8 bg-white">
    <div class="pl-4 lg:p-6">
      <h2 class="text-left text-2xl font-black mb-4">{{ $t("pack_avm.form.title") }}</h2>
      <p class="mb-6">{{ $t("pack_avm.form.subtitle") }}</p>

      <v-form ref="form" v-model="valid">
        <div class="flex flex-col mx-2">
          <h2 class="text-xl font-black my-4">{{ $t("shared.shipping_address") }}</h2>
          <v-row class="flex flex-col lg:flex-row lg:gap-4">
            <v-text-field v-model="formPackAvm.name.value" outlined label="Nombre*" placeholder="Nombre" :rules="formPackAvm.name.rules"></v-text-field>
            <v-text-field v-model="formPackAvm.lastName.value" outlined label="Apellidos*" placeholder="Apellidos" :rules="formPackAvm.lastName.rules"></v-text-field>
          </v-row>

          <v-row class="flex flex-col lg:flex-row gap-2 lg:gap-4">
            <v-text-field v-model="formPackAvm.phone.value" outlined label="Teléfono de contacto*" placeholder="Teléfono de contacto" :rules="formPackAvm.phone.rules"></v-text-field>
            <v-text-field v-model="formPackAvm.street.value" outlined label="Calle*" placeholder="Calle" :rules="formPackAvm.street.rules"></v-text-field>
          </v-row>

          <v-row class="flex flex-col lg:flex-row gap-2 lg:gap-4">
            <v-text-field v-model="formPackAvm.floor.value" outlined label="Piso, puerta*" placeholder="Piso, puerta" :rules="formPackAvm.floor.rules"></v-text-field>
            <v-text-field v-model="formPackAvm.postalCode.value" outlined label="Código postal*" placeholder="Código postal" :rules="formPackAvm.postalCode.rules"></v-text-field>
          </v-row>

          <v-row class="flex flex-col lg:flex-row gap-2 lg:gap-4 w-full">
            <v-text-field v-model="formPackAvm.city.value" outlined label="Ciudad*" placeholder="Ciudad" :rules="formPackAvm.city.rules"></v-text-field>
            <v-text-field v-model="formPackAvm.country.value" outlined label="País*" placeholder="País" readonly></v-text-field>
          </v-row>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  watch: {
    formPackAvm: {
      handler(formPackAvm) {
        this.$emit('input', formPackAvm);
      },
      deep: true,
    }
  },
  data() {
    return {
      valid: false,
      formPackAvm: {
        name: {
          value: null,
          rules: [
            v => !!v || this.$t("form.enter_name"),
          ]
        },
        lastName: {
          value: null,
          rules: [
            v => !!v || this.$t("form.enter_last_name"),
          ]
        },
        phone: {
          value: null,
          rules: [
            v => !!v || this.$t("form.enter_phone"),
            v => /^\d+$/.test(v) || this.$t("form.enter_only_digits"),
          ]
        },
        street: {
          value: null,
          rules: [
            v => !!v || this.$t("form.enter_street"),
          ]
        },
        floor: {
          value: null,
          rules: [
            v => !!v || this.$t("form.enter_floor"),
          ]
        },
        postalCode: {
          value: null,
          rules: [
            v => !!v || this.$t("form.enter_postal_code"),
            v => (v && v.length >= 5) || this.$t("form.postal_code_min_length"),
          ]
        },
        city: {
          value: null,
          rules: [
            v => !!v || this.$t("form.enter_city"),
          ]
        },
        country: {
          value: "España",
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-text-field .v-text-field--enclosed .v-text-field__details {
  margin-bottom: -25px !important;
  display: none !important;
}
.pack-form-box {
  border-radius: 16px;
  border: 1px solid #9b9b9b;
}
</style>
